<ion-app>
  <div class="responsive-app-container" [ngClass]="{'full-width': allowFullScreen}">
    <div class="app-shell">
      <div class="layout-busy-spinner" *ngIf="busyLoading">
        <viva-spinner color="var(--ion-text-color)"></viva-spinner>
      </div>

      <div class="ai-chat-icon" *ngIf="showBot">
        <viva-chat color="white" [messageText]="miniChatText"
          (onBotClicked)="aiChatClicked($event)" (onCloseBubble)="closeMiniChat()" [interactive]="true"></viva-chat>
      </div>

      <app-main-menu></app-main-menu>
      <ion-router-outlet #routerOutlet id="main-content"></ion-router-outlet>
    </div>
  </div>
</ion-app>

